import { render, staticRenderFns } from "./SchoolStaffAwayControl.vue?vue&type=template&id=375edc4a&scoped=true&"
import script from "./SchoolStaffAwayControl.vue?vue&type=script&lang=js&"
export * from "./SchoolStaffAwayControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375edc4a",
  null
  
)

export default component.exports